import type { InputHTMLAttributes } from "react";
import "../Switch/Switch.css";

export interface ToggleProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "type" | "onChange" | "checked"
> {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

/**
 * Just the on/off control, for places that draw their own row. Give it an
 * aria-label. Use Switch when you also want a label and description.
 * Example: <Toggle checked={on} onChange={setOn} aria-label="Insurance" />
 */
const Toggle = ({
  checked,
  onChange,
  className = "",
  ...rest
}: ToggleProps) => (
  <span className={`ds-switch__control ${className}`.trim()}>
    <input
      type="checkbox"
      role="switch"
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      {...rest}
    />
    <span className="ds-switch__track" aria-hidden="true" />
  </span>
);

export default Toggle;
